module.exports = __webpack_public_path__ + "assets/img/car25.d50a7846.jpg";